export enum Regelzone {
    TRANSNET_BW = 'TRANSNET_BW',
    TENNET = 'TENNET',
    AMPRION = 'AMPRION',
    _50_HERTZ = '_50_HERTZ',
    FLENSBURG = 'FLENSBURG'
}

export class RegelzoneItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): RegelzoneItem[] {
        return [
            new RegelzoneItem(Regelzone.TRANSNET_BW, 'TransnetBW'),
            new RegelzoneItem(Regelzone.TENNET, 'Tennet'),
            new RegelzoneItem(Regelzone.AMPRION, 'Amprion'),
            new RegelzoneItem(Regelzone._50_HERTZ, '50Hertz'),
            new RegelzoneItem(Regelzone.FLENSBURG, 'Flensburg'),
        ];
    }

}

